/*
Sohel 03/30/2023 2699762545 batch Name API Changes
Sohel 03/31/2023 2699762545 batch Name New API Changes
Ravi 04/03/2023 2699762545 Rename group code to letter group code
Ravi 04/03/2023 2699762545 removed download icon from action
Ravi 04/05/2023 2699762545 remove Active column from table
Ravi 04/06/2023 2699762545 changed placeholder name in search TextField
Ravi 04/07/2023 2699762545 Added Letter Code and Type textfield in search
Sohel 04/08/2023 2699762545 Added Download Batch Functionality
Ravi 04/10/2023 2699762545 Added Print icon and integrated Api
Ravi 04/10/2023 2699762545 disable print icon based on condition
Sohel 04/11/2023 2699762545 Added Print By and Print Date in Columns
Guru Prasad 04/11/2023 2699762545 Fixed alignments
Prakash 09/05/2023 2699762545 fixed icon issue  letter-batches in tab view.

*/
import React, {createRef, useEffect, useState, useContext} from 'react';
// import MaterialTable from "material-table";
import {tableIcons} from '../../../components/TableIcons/index';
import {makeStyles, Button, TextField} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import moment from 'moment';
import {tablePageRows, defaultRows} from '../../../constants/ReusableTablePagination';
import {httpPaginationPost} from '../../../util/Rest';
import {
  resetLetters,
  resetApproveBatch,
  downloadFileByUrl,
  printBatch,
} from '../../../redux/reducers/LetterBatches';
import GetAppIcon from '@material-ui/icons/GetApp';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {SuccessSnackbar} from '../../../components/CustomSnackBar';
import GuiTable from '../../../components/FormComponents/GuiTable';
import GuiTextField from './../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from './../../../components/FormComponents/GuiAutoComplete';
import {Form, Formik} from 'formik';
import {LETTER_TYPE} from '../../../constants/Lookup';
import {getDropDownData} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined';
import DialogBox from '../../../components/DialogBox';
import ViewCandidates from './ViewLetters';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
const useStyles = makeStyles((theme) => ({
  cardStyles: {
    whiteSpace: 'nowrap',
    padding: 10,
    marginTop: 20,
    marginBottom: 10,
    boxShadow:
      '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
  },

  toolTip: {
    zIndex: '9 !important',
  },

  batchNumber: {
    color: '#320469 ',
    cursor: 'pointer',
    borderBottom: '1px solid #000099',
    display: 'inline-block',
  },
  disabledBatchNumber: {
    color: '#676767',
    textDecoration: 'underline',
  },
}));
const BatchesTable = ({setValue, setBatchId, setBatchName}) => {
  const dispatch = useDispatch();
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState('');
  const [submit, setSubmit] = useState(false);
  const [ViewOpen, setViewOpen] = useState(false);
  const [tableData, setTableData] = useState('');
  // const [batchView, setbatchView] = useState(false);
  const columns = [
    {
      title: 'Batch Name',
      field: 'batchName',
      render: (rowData) => (
        <div
          className={`pointer ${classes1.batchNumber}`}
          onClick={() => {
            setBatchName(rowData?.batchName);
            setBatchId(rowData?.batchId);
            setValue(1);
          }}
        >
          {rowData.batchName}
        </div>
      ),
    },
    {
      title: 'Batch Status',
      field: 'batchStatus',
    },
    {
      title: 'Type',
      field: 'letterType',
    },
    {
      title: 'Group Code',
      field: 'groupCode',
    },
    {
      title: 'No Of Letters',
      field: 'noOfLetters',
      maxWidth: 100,
    },
    {
      title: 'Batch Executed Date',
      field: 'batchDate',
      render: (rowData) =>
        rowData.batchDate ? moment(rowData.batchDate.slice(0, 10)).format('MM/DD/YYYY') : '',
    },
    {
      title: 'Requested By',
      field: 'requestBy',
    },
    {
      title: 'Printed Date',
      field: 'printDate',
      render: (rowData) =>
        rowData.printDate ? moment(rowData.printDate.slice(0, 10)).format('MM/DD/YYYY') : '',
    },
    {
      title: 'Printed By',
      field: 'printBy',
    },
  ];

  const [arrayLast, setArrayLast] = useState(false);
  const tableRef = createRef();
  const {dropDownData} = useSelector(({newLetterMaintenance}) => newLetterMaintenance);

  const getOptions = (typeCode) => {
    let label = [];
    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    return label;
  };
  const {successMsg, isLoading, lettersDataStatus, printBatchStatus} = useSelector(
    ({letterBatches}) => letterBatches,
  );
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);

  useEffect(() => {
    if (lettersDataStatus === 200 || printBatchStatus === 200) {
      tableRef.current.onQueryChange();
      dispatch(resetLetters());
    }
  }, [lettersDataStatus, printBatchStatus]);
  useEffect(() => {
    dispatch(resetLetters());
    setBatchId(null);
    setBatchName(null);
  }, []);
  useEffect(() => {
    if (successMsg) {
      setTimeout(() => {
        dispatch(resetApproveBatch());
      }, 3000);
    }
  }, [successMsg]);
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  const initialValues = {
    batchName: '',
    batchStatus: '',
    groupCode: '',
    letterType: '',
  };
  const batchStatusOptions = [
    {key: 'Completed', value: 'Completed'},
    {key: 'Generated', value: 'Generated'},
    {key: 'Printed', value: 'Printed'},
  ];
  const handleSubmit = (values) => {
    setSearchData(values);
    setSubmit(true);
  };
  const onClear = () => {
    const data = {batchName: '', batchStatus: '', groupCode: '', letterType: ''};
    setSearchData(data);
    setSubmit(true);
  };
  const ViewDialogClose = () => {
    setViewOpen(false);
    // dispatch(resetLookDetails());
  };
  return (
    <>
      <h2 className="search-title">Letter Batch Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const {values, handleChange, handleBlur, setFieldValue, resetForm} = props;

          return (
            <div>
              <Form autoComplete="off">
                <div className="form-row standard-field-textfields new-standard-textfields">
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Batch Name`}
                      label="Batch Name"
                      className={` ${classes.labelName}`}
                      name="batchName"
                      value={values.batchName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </div>

                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="batchStatus"
                      id="batchStatus"
                      size="small"
                      value={values.batchStatus}
                      options={batchStatusOptions}
                      getOptionLabel={(option) => {
                        return option && option?.key ? option?.key : '';
                      }}
                      onChange={(e, value) => {
                        setFieldValue('batchStatus', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            label="Batch Status"
                            placeholder="Select Batch Status"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="letterType"
                      id="letterType"
                      size="small"
                      value={values.letterType}
                      options={getOptions(LETTER_TYPE).length > 0 ? getOptions(LETTER_TYPE) : []}
                      getOptionLabel={(option) => {
                        return option?.value ? option?.value : '';
                      }}
                      onChange={(e, value) => {
                        handleChange(e);
                        setFieldValue('letterType', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            label="Type"
                            placeholder="Select Type"
                          />
                        </div>
                      )}
                    />
                  </div>
                  <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                    <TextField
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Group Code`}
                      label="Group Code"
                      className={` ${classes.labelName}`}
                      name="groupCode"
                      value={values.groupCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </div>
                  <div className="col-md-4 col-lg-12 mb-3">

                    <div className="d-flex justify-content-md-start justify-content-lg-center">
                      <Button
                        variant="outlined"
                        className={`mr-1 reset-btn`}
                        onClick={() => {
                          resetForm();
                          onClear();
                        }}
                      >
      Reset
                      </Button>
                      <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
      Search
                      </Button>
                    </div>

                  </div>
                </div>

              </Form>
            </div>
          );
        }}
      </Formik>
      <div
        className={`custom-table custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields`}
      >
        <GuiTable
          icons={tableIcons}
          title=""
          columns={columns}
          isLoading={isLoading}
          tableRef={tableRef}
          data={(query) =>
            new Promise((resolve) => {
              const url = `newlettermaintenance/find/all/letterbatch`;
              const bodyObj = {
                limit: query.pageSize ? query.pageSize : null,
                orderDirection: query.orderDirection,
                orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                search: '',
                batchName: searchData?.batchName ? searchData?.batchName : '',
                groupCode: searchData?.groupCode ? searchData?.groupCode : '',
                letterType: searchData?.letterType?.value ? searchData?.letterType?.value : '',
                batchStatus: searchData?.batchStatus?.value ? searchData?.batchStatus?.value : '',
                page: submit ?
                  1 :
                  arrayLast && query?.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              httpPaginationPost(url, bodyObj)
                .then((response) => {
                  if (response?.status === 200) {
                    resolve({
                      data: response.data.response.resultObject ?
                        response.data.response.resultObject :
                        [],
                      page: response.data.response.page - 1,
                      totalCount: response.data.response.count,
                    });
                    setArrayLast(response.data.response.resultObject.length === 1);
                    setSubmit(false);
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  }
                })
                .catch((response) => {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                  dispatch({
                    type: 'FETCH_ERROR',
                    payload: response && response.message ? response.message : null,
                  });
                });
            })
          }
          actions={[
            (rowData) => ({
              icon: () => <GetAppIcon />,
              tooltip: 'Download Batch',
              disabled: !rowData?.documentKey || rowData?.letterType === 'Print Service',
              onClick: (event, rowData) => {
                dispatch(downloadFileByUrl({dockey: rowData?.documentKey}));
              },
            }),

            (rowData) => ({
              icon: () => <PrintOutlinedIcon />,
              tooltip: 'Print',
              disabled: rowData?.batchStatus === 'Printed' || rowData?.letterType === 'Print Service',
              onClick: (event, rowData) => {
                dispatch(printBatch(rowData?.letterBatchId));
              },
            }),
            {
              icon: () => <VisibilityOutlinedIcon />,
              tooltip: 'View',
              onClick: (event, rowData) => {
                setBatchName(rowData?.batchName);
                setBatchId(rowData?.batchId);
                setTableData(rowData);
                setViewOpen(true);
              },
            },
          ]}
          options={{
            toolbar: false,
            search: false,
            debounceInterval: 500,
            pageSize: defaultRows,
            pageSizeOptions: tablePageRows,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
        />
      </div>
      <DialogBox
        open={ViewOpen}
        dialogClose={ViewDialogClose}
        title={`Batch Name : ${tableData.batchName}`}
        maxWidth="xl"
      >
        <ViewCandidates batchName={`${tableData?.batchName}`} batchId={`${tableData?.batchId}`} />
      </DialogBox>
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default BatchesTable;
